import { osnovaApi } from '../base';
import type { VatRatePoint } from '../types';

/** Справочник ставок НДС (миграция 0225) — общий для сметы и экономиста.
 *  Хранятся точки изменения: ставка действует с `effective_date` до следующей
 *  точки. Расчёты берут ставку ПО ДАТЕ документа, поэтому строки не заменяют
 *  друг друга, а накапливаются. */
export const vatRatesApi = osnovaApi.injectEndpoints({
  endpoints: (b) => ({
    listVatRates: b.query<{ items: VatRatePoint[] }, void>({
      query: () => '/vat-rates',
      providesTags: ['VatRate'],
    }),

    /** Завести или поправить ставку (идемпотентно по дате начала действия). */
    upsertVatRate: b.mutation<
      VatRatePoint,
      { effective_date: string; rate_pct: number; basis?: string; note?: string }
    >({
      query: (body) => ({ url: '/vat-rates', method: 'POST', body }),
      invalidatesTags: ['VatRate'],
    }),

    /** Снять ошибочно заведённую точку (по дате начала действия). */
    deleteVatRate: b.mutation<{ deleted: string }, string>({
      query: (effectiveDate) => ({ url: `/vat-rates/${effectiveDate}`, method: 'DELETE' }),
      invalidatesTags: ['VatRate'],
    }),
  }),
});

export const { useListVatRatesQuery, useUpsertVatRateMutation, useDeleteVatRateMutation } =
  vatRatesApi;
